/**
 * Fatia visível de um iframe alto demais para a janela (embed em site externo).
 * `position: fixed` dentro do iframe ancora no documento do iframe, não no viewport do host.
 *
 * Manter a fórmula igual em `backend/public/js/landing-embed.js` (`computeVisibleSlice`).
 */
export type IframeVisibleSlice = {
  visibleTop: number
  visibleHeight: number
}

export function computeIframeVisibleSlice(
  iframeRect: Pick<DOMRect, 'top' | 'bottom'>,
  viewportHeight: number,
): IframeVisibleSlice {
  const viewH = Math.max(0, viewportHeight)
  const visibleTopParent = Math.max(0, iframeRect.top)
  const visibleBottomParent = Math.min(viewH, iframeRect.bottom)
  const visibleHeight = Math.max(0, visibleBottomParent - visibleTopParent)
  const visibleTop = Math.max(0, -iframeRect.top)

  return { visibleTop, visibleHeight }
}

export const LANDING_EMBED_VIEWPORT_EVENT = 'legalprime:landing-embed-viewport'
